/**
 * Hoort het tabblad 'Onderzoek' in een afspraak te staan?
 *
 * Bij ELK huisbezoek, zodra de impactfunctionaliteit aanstaat — ook als er nog
 * geen onderzoek aan het huishouden hangt (Gijs, 2026-09-11). Het tabblad zegt
 * dan zelf dat er nog niets gekoppeld is en waar dat kan. Tot vandaag verscheen
 * het pas ná het koppelen, en dan ontdekte je in de auto dat je niets kon delen.
 *
 * @param {object} args
 * @param {boolean} args.isAddressVisit - Afspraak van het type huisbezoek, gekoppeld aan een huishouden
 * @param {boolean} args.impactFunctionality - Staat de impactmodule aan voor deze organisatie
 * @returns {boolean}
 */
const householdResearchTabVisible = ({ isAddressVisit, impactFunctionality } = {}) =>
    Boolean(isAddressVisit && impactFunctionality)

export default householdResearchTabVisible
